import { useIsDesktopViewport } from '@ui/shared/viewport/useIsDesktopViewport';
import { RewardsScreenDesktop } from '@ui/desktop/rewards/RewardsScreen.desktop';
import { RewardsScreenPhone } from '@ui/phone/rewards/RewardsScreen.phone';

/**
 * `RewardsScreen` — the switch component (design/screens/responsive-strategy.md
 * §2.2). The ONLY Rewards import `App.tsx` uses. Picks the phone- or
 * desktop-shaped tree at runtime via `useIsDesktopViewport()`, so the same
 * route (`rewards`) serves correctly whichever device opens it — fixes the
 * severity-1 bug where a phone visiting this route got the raw desktop
 * 3-column table with zero adaptation (docs/reviews/design-review-mobile-rewards-weekly-review.md).
 *
 * Both trees consume the same domain layer/contracts; only the render tree
 * forks here. Neither tree is imported anywhere else in the app — this file
 * is the single decision point.
 */
export function RewardsScreen() {
  const isDesktop = useIsDesktopViewport();
  return isDesktop ? <RewardsScreenDesktop /> : <RewardsScreenPhone />;
}
